import React, { useEffect, useState } from "react";
import { corefetch, ImageURL } from "../../../Util/axios_core_helper";

const BannerSection = ({ id }) => {
  const [slides, setSlides] = useState([]);

  const fetchData = async () => {
    try {
      const list = await corefetch(
        `Banner/GetCommonBannerDetails?displayedInID=${id}`
      );
      if (list && list.length > 0) {
        setSlides(list);
      } else {
        setSlides([]);
      }
    } catch (error) {
      setSlides([]);
      console.error("Error fetching list:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    if (slides?.length) {
      var interleaveOffset = 0.5;
      var swiperOptions = {
        loop: true,
        speed: 1000,

        parallax: true,
        autoplay: {
          delay: 6500,
          disableOnInteraction: false,
        },
        autoplay: true,
        watchSlidesProgress: true,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
          renderBullet: function (index, className) {
            return '<span class="' + className + '">' + (index + 1) + "</span>";
          },
        },

        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },

        on: {
          progress: function () {
            var swiper = this;
            for (var i = 0; i < swiper.slides.length; i++) {
              var slideProgress = swiper.slides[i].progress;
              var innerOffset = swiper.width * interleaveOffset;
              var innerTranslate = slideProgress * innerOffset;
              swiper.slides[i].querySelector(".slide-inner").style.transform =
                "translate3d(" + innerTranslate + "px, 0, 0)";
            }
          },

          touchStart: function () {
            var swiper = this;
            for (var i = 0; i < swiper.slides.length; i++) {
              swiper.slides[i].style.transition = "";
            }
          },

          setTransition: function (speed) {
            var swiper = this;
            for (var i = 0; i < swiper.slides.length; i++) {
              swiper.slides[i].style.transition = speed + "ms";
              swiper.slides[i].querySelector(".slide-inner").style.transition =
                speed + "ms";
            }
          },
        },
      };

      var swiper = new Swiper(".swiper-container", swiperOptions);
      if (swiper) {
        swiper.destroy(true, true);
        swiper = null; // optional: clear reference
      }
      swiper = new Swiper(".swiper-container", swiperOptions);

      // DATA BACKGROUND IMAGE
      var sliderBgSetting = $(".slide-bg-image");
      sliderBgSetting.each(function (indx) {
        if ($(this).attr("data-background")) {
          $(this).css(
            "background-image",
            "url(" + $(this).data("background") + ")"
          );
        }
      });
    }
  }, [slides]);

  // if (!slides || slides.length == 0) {
  //   return null;
  // }
  return (
    <>
      <section className="wpo-hero-slider wpo-hero-slider-s3">
        <div className="swiper-container">
          <div className="swiper-wrapper">
            {slides && slides.length > 0 ? (
              slides.map((slide, index) => {
                const encodedURL = slide.oldImagePath
                  .replace(/\(/g, "%28")
                  .replace(/\)/g, "%29")
                  .replace(/ /g, "%20");

                const fullURL = `${ImageURL}${encodedURL}`;

                return (
                  <div className="swiper-slide banner" key={index}>
                    <div
                      className="slide-inner slide-bg-image banner"
                      style={{
                        backgroundImage: `url(${fullURL})`,
                      }}
                    >
                      <div className="container-fluid">
                        <div className="slide-content-wrap">
                          <div className="slide-content">
                            <div
                              data-swiper-parallax={300}
                              className="slide-title"
                            >
                              <h2 id="QuinceneraId">{slide.title}</h2>
                            </div>
                            <div
                              data-swiper-parallax={400}
                              className="slide-text"
                            >
                              <p>{slide.shortDescription}</p>
                            </div>
                            <div className="clearfix" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })
            ) : (
              <div
                className="loading-message"
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  marginLeft: "40%",
                }}
              >
                <h2>Loading...</h2>
              </div>
            )}
          </div>
          <div className="swiper-pagination" />
        </div>
      </section>
    </>
  );
};

export default BannerSection;
